import { CurrentMoment } from '../../CurrentMoment';
import type { ColorPalette } from '../../ColorPalette';
import { AbstractScheduleEvent } from './AbstractScheduleEvent';

/**
 * Weekday + time schedule event (anchor: weekday).
 */
export class WeekdayScheduleEvent extends AbstractScheduleEvent {
	private readonly weekday: number;

	constructor(
		weekday: number,
		private readonly time: string,
		colorPalette: ColorPalette,
		private readonly timezone: string | null
	) {
		super(colorPalette);
		this.weekday = CurrentMoment.clampWeekday(weekday);
	}

	getLatestScheduleEvent(): Date {
		return CurrentMoment.lastWeekdayScheduleAt(this.weekday, this.time, this.timezone);
	}

	getNextBoundaryAfter(): number | null {
		return CurrentMoment.nextWeekdayBoundaryMs(this.weekday, this.time, this.timezone);
	}
}
